import { Modal } from 'antd';

import './style.less';

function NewAuthorModal({ open, onCancel, onOk }) {
  return (
    <Modal
      open={open}
      okText="Evet"
      cancelText="Hayır"
      onCancel={onCancel}
      destroyOnClose
      onOk={onOk}
      centered
    >
      <div className="modal-body-wrapper">Aradığınız yazarın sistemde bulunmadığına ve yeni bir yazar eklemek istediğinize emin misiniz?</div>
    </Modal>
  );
}

export default NewAuthorModal;
